import { useSearchParams } from 'react-router-dom'
import { SortingState } from '@tanstack/react-table'
import { useEffect, useState } from 'react'
/**
 * Custom hook that returns the initial sort value for a table.
 * That is, no sort query param is present in the URL
 * when a sort value is in the URL the TableComponent will handle the sort.
 * @param sort - SortingState. The default sort value. It has the format of `columnId:asc` or `columnId.keyword:desc` or `columnId.plain:asc.
 * @returns {SortingState} initial sort value.
 */
export function useInitialTableSort(sort: string | undefined): SortingState | undefined {
  const [searchParams] = useSearchParams()
  const [initialSort, setInitialSort] = useState<SortingState | undefined>(undefined)

  useEffect(() => {
    const urlSort = searchParams.get(`sort`)
    if (urlSort !== null || !sort) {
      setInitialSort(undefined)
    } else {
      let sortParams = sort.split(`:`)
      setInitialSort([{ id: sortParams[0].split(`.`)[0], desc: sortParams[1] === `desc` }])
    }
  }, [sort, searchParams.get(`sort`)])

  return initialSort
}
